<!-- 
  Created by:Upendram Reddy Tanuja
  Created on: 23-Jul-2019 12:00 PM
  Purpose:  Link expiry page
-->

<div class="container">
  <div class="row ">
    <div class="col-md-6 offset-md-3">
      <mat-card class="example-card text-center">
        <mat-card-header>
          <mat-card-title>Link Expired</mat-card-title>
        </mat-card-header>
      </mat-card>
    </div>
  </div>
</div>